define("shared/components/shared/carousel/inner", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="carousel-inner eCP--slide u--m__b__0" role="listbox" ...attributes>
    {{#if (has-block)}}
      {{#each @carouselMediaItems as |media idx|}}
        <div
          aria-selected={{is-equal idx @index}}
          class={{concat-classes "item cCP--slide__item" (if (is-equal idx @index) "active")}}
          data-test-id={{(if (is-equal idx @index) "shared-carousel-active")}}
          role="option"
        >
          {{yield media idx}}
        </div>
      {{/each}}
    {{else}}
      {{#each @carouselMediaItems as |media idx|}}
        <div class={{concat-classes "item" (if (is-equal idx @index) "active")}} role="listbox">
          {{#if (is-equal media.mediaType "video")}}
            <video
              alt={{media.caption}}
              class="video-js vjs-default-skin"
              controls
              data-setup="{'controls': true, 'autoplay': true, 'preload': 'auto', 'loop': 'true'}"
              height="640"
              preload="auto"
              width="640"
            >
              <source src={{media.standardResVideoUrl}} type="video/mp4" />
            </video>
          {{else}}
            <img
              alt={{media.caption}}
              aria-selected={{is-equal idx @index}}
              class="o--media"
              role="option"
              src={{media.standardResUrl}}
            />
          {{/if}}
        </div>
      {{/each}}
    {{/if}}
  </div>
  */
  {
    "id": "Wa/XZHHP",
    "block": "[[[11,0],[24,0,\"carousel-inner eCP--slide u--m__b__0\"],[24,\"role\",\"listbox\"],[17,1],[12],[1,\"\\n\"],[41,[48,[30,8]],[[[42,[28,[37,3],[[28,[37,3],[[30,2]],null]],null],null,[[[1,\"      \"],[10,0],[15,\"aria-selected\",[28,[37,4],[[30,4],[30,5]],null]],[15,0,[28,[37,5],[\"item cCP--slide__item\",[52,[28,[37,4],[[30,4],[30,5]],null],\"active\"]],null]],[15,\"data-test-id\",[52,[28,[37,4],[[30,4],[30,5]],null],\"shared-carousel-active\"]],[14,\"role\",\"option\"],[12],[1,\"\\n        \"],[18,8,[[30,3],[30,4]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[3,4]],null]],[]],[[[42,[28,[37,3],[[28,[37,3],[[30,2]],null]],null],null,[[[1,\"      \"],[10,0],[15,0,[28,[37,5],[\"item\",[52,[28,[37,4],[[30,7],[30,5]],null],\"active\"]],null]],[14,\"role\",\"listbox\"],[12],[1,\"\\n\"],[41,[28,[37,4],[[30,6,[\"mediaType\"]],\"video\"],null],[[[1,\"          \"],[10,\"video\"],[15,\"alt\",[30,6,[\"caption\"]]],[14,0,\"video-js vjs-default-skin\"],[14,\"controls\",\"\"],[14,\"data-setup\",\"{'controls': true, 'autoplay': true, 'preload': 'auto', 'loop': 'true'}\"],[14,\"height\",\"640\"],[14,\"preload\",\"auto\"],[14,\"width\",\"640\"],[12],[1,\"\\n            \"],[10,\"source\"],[15,\"src\",[30,6,[\"standardResVideoUrl\"]]],[14,4,\"video/mp4\"],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,\"img\"],[15,\"alt\",[30,6,[\"caption\"]]],[15,\"aria-selected\",[28,[37,4],[[30,7],[30,5]],null]],[14,0,\"o--media\"],[14,\"role\",\"option\"],[15,\"src\",[30,6,[\"standardResUrl\"]]],[12],[13],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[6,7]],null]],[]]],[13]],[\"&attrs\",\"@carouselMediaItems\",\"media\",\"idx\",\"@index\",\"media\",\"idx\",\"&default\"],false,[\"if\",\"has-block\",\"each\",\"-track-array\",\"is-equal\",\"concat-classes\",\"yield\"]]",
    "moduleName": "shared/components/shared/carousel/inner.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});